module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-activity-item box"
  }, [_c('div', {
    staticClass: "level is-mobile"
  }, [_c('div', {
    staticClass: "level-item has-text-left",
    on: {
      "click": _vm.goToFeedbackPage
    }
  }, [_c('p', {
    staticClass: "lxm-activity-item__name"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "level-item has-text-centered",
    on: {
      "click": _vm.goToFeedbackPage
    }
  }, [_c('p', {
    staticClass: "lxm-activity-item__value"
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('p', {
    staticClass: "lxm-activity-item__sub"
  }, [_vm._v(_vm._s(_vm.valueSuffix))])]), _vm._v(" "), _c('div', {
    staticClass: "level-item scan-icon-item",
    on: {
      "click": _vm.onScanClicked
    }
  }, [_c('p', {
    staticClass: "lxm-activity-item__value scan-icon"
  }, [_vm._v("scan")]), _vm._v(" "), _c('p', {
    staticClass: "lxm-activity-item__sub"
  }, [_vm._v("扫码签到")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7701f0c3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7701f0c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmActivityItem.vue
// module id = 871
// module chunks = 0